export default __webpack_public_path__ + "static/media/a3.9da4de25.png";